import AboutUs from "../AboutUs";

function MaisonSambinAboutUs() {
  return (
    <AboutUs
      className="Maison_Sambin about"
      titleKey="maisonSambin.about.title"
      textKey="maisonSambin.about.text"
    />
  );
}

export default MaisonSambinAboutUs;
